// extracted by mini-css-extract-plugin
export default {"topNav":"QR-z","category":"RR-z","noArrow":"SR-z","alternative":"TR-z","topLevelNavItem":"UR-z","navContainer":"VR-z","subcategoryHeading":"WR-z","subcategory":"XR-z"};